import PropTypes from 'prop-types';
import { useEffect } from 'react';

import useHistory from 'routing/useHistory';

import workspaceRoutes from './common/Routes';

// https://stackoverflow.com/questions/52912238/render-methods-should-be-a-pure-function-of-props-and-state
const WorkspaceInputConfiguration = ({ url }) => {
  const history = useHistory();

  useEffect(() => {
    history.push(url);
  }, [history, url]);

  return null;
};

WorkspaceInputConfiguration.propTypes = {
  url: PropTypes.string,
};

WorkspaceInputConfiguration.defaultProps = {
  url: workspaceRoutes.INTEGRATIONS.Workspace.ACTIVITYAPI.index,
};

export default WorkspaceInputConfiguration;
